export default "__VITE_ASSET__CG6ju6zJ__"